import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from 'libraries/service/auth/auth.service';
import { Yii } from "libraries/interfaces/Yii";
import { ConfigurationResourceService } from "../../../../libraries/service/resources/configuration/configurationResource.service";
import { CONFIG_HOME, IHomeConfig } from "../../../../app_home/home-domain.service";
import { Subscription } from "rxjs";
import { IAfidiumConnectConfig, IAfidiumConnectLink, IAuthForm } from "../../model/afidium-connect.model";
import { wenji } from "libraries/interfaces/IWenji";

const DEFAULT_GLOBAL_NAME: string = 'AFIDIUM';

class Wording {
    public readonly onLogin: string = Yii.t('wui-app-js', 'Connexion en cours...');
    public readonly createAccount: string = Yii.t('wui-app-js', 'Créer un compte');
    public readonly forgotPassword: string = Yii.t('wui-app-js', 'Mot de passe oublié ?');
    public readonly missingField: string = Yii.t('wui-app-js','Veuillez remplir les champs');
    public readonly needLogin: string = Yii.t('wui-app-js','Votre session a expiré, veuillez vous authentifier');
}

@Component({
    selector: 'login',
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
    public afidiumConnectConfig: IAfidiumConnectConfig = wenji?.connect;
    public onLogin: boolean = false;
    public message: string;
    public globalName: string = null;
    public afidiumConnectLinks: IAfidiumConnectLink;
    public readonly wording: Wording = new Wording();
    private globalNameSubscription: Subscription;
    private loginSubscription: Subscription;
    private authServiceLoginSubscription: Subscription;
    constructor(
        private authService: AuthService,
        private readonly configurationResourceService: ConfigurationResourceService,
    ) { }

    public async ngOnInit(): Promise<void> {
        this.initGlobalName();
        this.initMessage();
        sessionStorage.setItem('childAppName', 'Login');
        if (!this.afidiumConnectConfig.bypass) {
            // #34525 force logout if not token to logout next line just clear localStorage
            await this.authService.logoutAfidiumConnect(false);
        }
        if (!this.afidiumConnectConfig?.hideLoginLinks) {
            this.initAfidiumConnectLinks();
        }

    }

    public ngOnDestroy(): void {
        this.globalNameSubscription.unsubscribe();
        if (this.loginSubscription) {
            this.loginSubscription.unsubscribe();
        }
        if (this.authServiceLoginSubscription) {
            this.authServiceLoginSubscription.unsubscribe();
        }
    }

    public submitLogin(authForm: IAuthForm): void {
        this.onLogin = true;
        this.message = null;
        if (this.afidiumConnectConfig?.bypass) {
            this.authService.login(authForm.login);
            this.authServiceLoginSubscription = this.authService.errorLoginMessageObservable.subscribe((errorLoginMessage: string) => {
                this.setMessage(errorLoginMessage);
            });
        } else {
            this.login(authForm);
        }
    }

    private initGlobalName(): void {
        this.globalNameSubscription = this.configurationResourceService.get(['wui', 'config', 'home', 'home.json'], CONFIG_HOME)
            .subscribe((homeConfig: IHomeConfig): void => {
                this.globalName = homeConfig?.globalName ?? DEFAULT_GLOBAL_NAME;
            });
    }

    private initMessage(): void {
        if (this.authService.redirectUrl) {
            this.message = this.wording.needLogin;
        }
    }

    private initAfidiumConnectLinks(): void {
        this.authService.initAfidiumConnect();
        if (this.authService.afidiumConnect.isConfigValid()) {
            this.afidiumConnectLinks = {
                createAccountLink: this.authService.afidiumConnect.getCreateAccountLink(),
                forgotPasswordLink: this.authService.afidiumConnect.getForgotPasswordLink()
            };
        }
    }

    private login(auth: IAuthForm): void {
        this.authService.initAfidiumConnect(); // create new instance for remove last information on login
        if (this.authService.afidiumConnect.isConfigValid()) {
            this.authService.afidiumConnect.setAuth(auth);
            if (this.authService.afidiumConnect.isAuthValid()) {
                this.loginSubscription = this.authService.loginAfidiumConnect().subscribe({
                    complete: async (): Promise<void> => {
                        this.onLogin = false;
                        this.message = this.authService.afidiumConnect.apiErrorMessage ?? null;
                        if (this.authService.afidiumConnect.isSamResponseValid()) {
                            this.authService.storeAfidiumConnectToken();
                            await this.authService.redirect();
                        }
                    }});
            } else {
                this.setMessage(this.wording.missingField);
            }
        } else {
            this.setMessage(this.authService.afidiumConnect.getInvalidConfigMessage());
        }
    }

    private setMessage(message: string): void {
        this.onLogin = false;
        this.message = message;
    }
}
